import inlineEditInputTemplate from './inlineEditInput.tpl.html';

export class InlineEditInput {
  constructor($scope, $translate) {
    Object.assign(this, {
      $scope,
      $translate,
    });

    this.editMode = false;
  }

  enterEditMode() {
    this.editMode = true;
    this.previousValue = this.value;
  }

  confirm() {
    this.onSave({ id: this.modelId, value: this.value });
    this.editMode = false;
  }

  cancel() {
    if (this.onCancel) {
      this.onCancel();
    }

    this.editMode = false;
    this.value = this.previousValue;
    this.previousValue = undefined;
  }
}

InlineEditInput.$inject = [
  '$scope', '$translate',
];

export const inlineEditInput = {
  template: inlineEditInputTemplate,
  controller: InlineEditInput,
  bindings: {
    modelId: '<',
    disabled: '<',
    value: '<',
    onSave: '&',
    onCancel: '&?',
    size: '@?',
  },
};
